import { Link } from "react-router-dom";
import { ARTICLES, getHot } from "@/mocks/articles";
import { getCategory } from "@/mocks/categories";
import { formatViews, parseDate } from "@/lib/site";
import { RankItem } from "@/components/ui/ArticleView";

export default function Hero() {
  const lead = ARTICLES.find((a) => a.featured) ?? ARTICLES[0];
  const leadCat = getCategory(lead.category);
  const rank = getHot(5);

  const stats = [
    { icon: "ri-user-heart-line", value: "128", label: "入驻圈内信源" },
    { icon: "ri-newspaper-line", value: "486", label: "累计更新报道" },
    { icon: "ri-flashlight-line", value: "3100万+", label: "累计阅读热度" },
  ];

  return (
    <section className="container-page pt-6 md:pt-8">
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        {/* 头条大图 */}
        <Link
          to={`/article/${lead.slug}`}
          className="group relative col-span-1 flex min-h-[360px] flex-col justify-end overflow-hidden rounded-lg md:min-h-[420px] lg:col-span-2 lg:min-h-[460px]"
        >
          <img
            src={lead.image}
            alt={lead.title}
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/40 to-transparent"></div>
          <div className="relative z-10 p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded-sm bg-primary-500 px-2 py-1 text-xs font-bold text-background-50">
                <i className="ri-fire-fill"></i>今日头条
              </span>
              <span className="inline-flex items-center gap-1 rounded-sm bg-background-50/15 px-2 py-1 text-xs font-semibold text-background-50 backdrop-blur">
                <i className={leadCat?.icon}></i>
                {leadCat?.source}
              </span>
            </div>
            <h2 className="mt-3 max-w-3xl font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl md:leading-tight">
              {lead.title}
            </h2>
            <p className="mt-3 max-w-2xl line-clamp-2 text-sm leading-relaxed text-background-200/90 md:text-base">
              {lead.excerpt}
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-3 text-xs text-background-100/80">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-eye-line"></i>
                {formatViews(lead.views)} 阅读
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-time-line"></i>
                {parseDate(lead.date)} · {lead.readTime}
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-sm bg-primary-500 px-2 py-0.5 font-semibold text-background-50">
                立即阅读 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </div>
        </Link>

        {/* 热瓜榜 */}
        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
          <div className="flex items-center justify-between border-b border-background-200 bg-background-100 px-4 py-3">
            <h3 className="flex items-center gap-2 font-heading text-base font-extrabold text-foreground-950">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-flashlight-fill"></i>
              </span>
              热瓜榜 TOP 5
            </h3>
            <span className="text-xs text-foreground-400">24H 热度</span>
          </div>
          <div className="px-4 py-1">
            {rank.map((a, i) => (
              <RankItem key={a.slug} a={a} index={i} />
            ))}
          </div>
          <div className="border-t border-background-200 px-4 py-2.5">
            <p className="flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-keyhole-line text-primary-500"></i>
              来源均为匿名圈内信源，仅供参考娱乐
            </p>
          </div>
        </div>
      </div>

      {/* 快捷数据条 */}
      <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {stats.map((s) => (
          <div
            key={s.label}
            className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 px-5 py-4"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-600">
              <i className={s.icon}></i>
            </span>
            <div>
              <p className="font-heading text-xl font-extrabold text-foreground-950">
                {s.value}
              </p>
              <p className="text-xs text-foreground-500">{s.label}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}